/* RESPONSIBLE TEAM: team-channels */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-controllers */
import { alias, notEmpty, not } from '@ember/object/computed';
import IntegrateBaseController from 'embercom/controllers/apps/app/integrations-hub/integrate-base-controller';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';

let OauthTokensController = IntegrateBaseController.extend({
  intl: service(),
  notificationsService: service(),
  intercomConfirmService: service(),
  oauthTokens: alias('model'),
  showTable: notEmpty('model'),
  emptyState: not('showTable'),

  async showRevokeConfirmation(oauthToken) {
    let confirmOptions = {
      title: this.intl.t('account.oauth-tokens.revoke-token-confirmation-title'),
      body: this.intl.t('account.oauth-tokens.revoke-token-confirmation-body'),
      confirmButtonText: this.intl.t('account.oauth-tokens.revoke'),
      cancelButtonText: this.intl.t('account.oauth-tokens.cancel'),
      primaryButtonType: 'primary-destructive',
    };

    let confirmed = await this.intercomConfirmService.confirm(confirmOptions);
    if (confirmed) {
      await this.revoke.perform(oauthToken);
    }
  },

  revoke: task(function* (oauthToken) {
    try {
      yield oauthToken.destroyRecord();
      this.notificationsService.notifyConfirmation(
        this.intl.t('account.oauth-tokens.revoke-success'),
      );
    } catch (err) {
      this.notificationsService.notifyError(this.intl.t('account.oauth-tokens.revoke-error'));
    }
  }),
});

export default OauthTokensController;
